import styled from 'styled-components';
import { Text } from '@cko/primitives';

export const RowContainer = styled.div`
  display: flex;
  gap: var(--layout-soybean);
  margin-bottom: var(--layout-soybean);
`;

export const LabelText = styled(Text)`
  color: var(--base-text-secondary);
  font: var(--body-xs-medium);
  width: 84px;
`;

export const ValueText = styled(Text)`
  font: var(--body-xs-medium);
`;
